import React from 'react'

interface SpinnerProps {
  width?: number
  height?: number
  ariaLabel?: string
  className?: string
  trackColor?: string
  circleColor?: string
  strokeWidth?: number
  animationDurationSpeed?: number
  fill?: string
}

function Spinner({
  width = 18,
  height = 18,
  ariaLabel = 'Loading',
  className = 'relative',
  trackColor = 'rgba(255,255,255,0.3)',
  circleColor = 'rgba(255,255,255,1)',
  strokeWidth = 2.4,
  animationDurationSpeed = 1.5,
  fill,
}: SpinnerProps) {
  return (
    <div role="status" aria-label={ariaLabel} className={className}>
      {/* Track */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
      >
        <circle
          cx="9"
          cy="9"
          r="6.1"
          fill={fill || 'none'}
          stroke={trackColor}
          strokeWidth={strokeWidth}
        />
      </svg>

      {/* Rotating Circle */}
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width={width}
        height={height}
        viewBox="0 0 18 18"
        fill="none"
        className="absolute inset-0 animate-spin"
        style={{ animationDuration: `${animationDurationSpeed}s` }}
      >
        <path
          d="M9 2.9 A 6.1 6.1 0 0 1 15.1 9"
          fill={fill || 'none'}
          stroke={circleColor}
          strokeWidth={strokeWidth}
          strokeLinecap="round"
        />
      </svg>
    </div>
  )
}

export default Spinner
